import React from 'react';
import { motion } from 'framer-motion';
import { Check, Flame, ThermometerSun, Snowflake, Wind, Wrench } from 'lucide-react';
import { ServicePageHero } from '../components/ServicePageHero';
import { CTASection } from '../components/CTASection';
import { Link } from 'react-router-dom';
export function CoolingHire() {
  const features = ['Portable AC units', 'Evaporative coolers', 'Cooling fans', 'Emergency response', 'Nationwide 24/7', 'All environments'];
  const relatedServices = [{
    title: 'Boiler Hire',
    icon: Flame,
    path: '/boiler-hire'
  }, {
    title: 'Heater Hire',
    icon: ThermometerSun,
    path: '/heater-hire'
  }, {
    title: 'Chiller Hire',
    icon: Snowflake,
    path: '/chiller-hire'
  }, {
    title: 'Ancillaries',
    icon: Wrench,
    path: '/ancillaries'
  }];
  return <main className="flex-grow" data-id="element-417">
      <ServicePageHero title="Cooling Hire" subtitle="Portable air conditioning units, evaporative coolers and cooling fans for all environments." bgImage="https://rapidenergy.co.uk/wp-content/uploads/2026/03/Rapid-Energy-Fleet.webp" data-id="element-418" />

      <section className="py-20 bg-white" data-id="element-419">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-420">
          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-421">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2" data-id="element-422">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark mb-6" data-id="element-423">
                Portable Cooling Solutions
              </h2>

              <div className="space-y-4 text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-424">
                <p data-id="element-425">
                  We provide an extensive range of portable cooling equipment
                  designed to tackle heat in any environment. From small server
                  rooms to large open-plan offices and industrial spaces, our
                  cooling hire solutions are ready for immediate deployment.
                </p>
                <p data-id="element-426">
                  Our fleet includes highly efficient portable air conditioning
                  units, powerful evaporative coolers, and high-volume cooling
                  fans. Whether you need to maintain critical temperatures for
                  IT equipment or ensure comfort for staff and customers during
                  a heatwave, we have the right equipment for the job.
                </p>
                <p data-id="element-427">
                  When temperatures soar unexpectedly, our emergency cooling
                  response team is available 24/7. We can deliver and set up
                  temporary cooling systems nationwide, often within hours of
                  your call, minimizing downtime and discomfort.
                </p>
                <p data-id="element-428">
                  Not sure what you need? Our experienced team can conduct rapid
                  assessments to recommend the most effective and
                  energy-efficient cooling strategy for your specific space and
                  requirements.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-429">
                {features.map((feature, i) => <div key={i} className="flex items-start" data-id="element-430">
                    <div className="bg-brand-green/20 p-1 rounded-full mr-3 mt-1 flex-shrink-0" data-id="element-431">
                      <Check className="w-4 h-4 text-brand-dark" data-id="element-432" />
                    </div>
                    <span className="text-sm font-medium text-brand-dark" data-id="element-433">
                      {feature}
                    </span>
                  </div>)}
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2 sticky top-24" data-id="element-434">
              <img src="https://rapidenergy.co.uk/wp-content/uploads/2025/04/200kW-AHU.webp" alt="200kW Air Handling Unit" className="rounded-2xl shadow-2xl w-full object-cover h-[500px]" data-id="element-435" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-16 bg-brand-light" data-id="element-436">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-437">
          <h3 className="text-2xl font-heading font-bold text-brand-dark mb-8 text-center" data-id="element-438">
            Related Services
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-439">
            {relatedServices.map((service, index) => <Link key={index} to={service.path} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group flex flex-col items-center text-center" data-id="element-440">
                <div className="w-12 h-12 bg-brand-light rounded-lg flex items-center justify-center mb-4 group-hover:bg-brand-green/20 transition-colors" data-id="element-441">
                  <service.icon className="w-6 h-6 text-brand-dark group-hover:text-brand-green transition-colors" data-id="element-442" />
                </div>
                <h4 className="font-heading font-bold text-brand-dark group-hover:text-brand-green transition-colors" data-id="element-443">
                  {service.title}
                </h4>
              </Link>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-444" />
    </main>;
}